import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Container, Jumbo, Tabs, tokens } from '@treams/treams-ui';

import GoalLabelEditor, { GoalLabelCreator } from './GoalLabelEditor';
import GoalLabelsListContainer from './GoalLabelsListContainer';
import GoalTemplateEditor, { GoalTemplateCreator } from './GoalTemplateEditor';
import GoalTemplateListContainer from './GoalTemplateListContainer';

export default function GoalsSettings() {
	const { t } = useTranslation();

	return (
		<>
			<Jumbo
				title={t('settings.goals.title')}
				description={t('settings.goals.description')}
				footer={
					<Tabs.Container mb="-1px">
						<Tabs.Item
							title={t('settings.goals.title')}
							path={['/settings/goals/templates', '/settings/goals/templates/:id']}
						/>
						<Tabs.Item
							title={t('settings.goals.labelTitle')}
							path={['/settings/goals/labels', '/settings/goals/labels/:id']}
						/>
					</Tabs.Container>
				}
			/>
			<Container pt={`${tokens.gap.page}px`} pb={4}>
				<Switch>
					<Route path="/settings/goals/templates/new">
						<GoalTemplateCreator />
					</Route>
					<Route path="/settings/goals/templates/:id">
						{({ match }) => <GoalTemplateEditor id={match!.params.id!} />}
					</Route>
					<Route path="/settings/goals/templates">
						<GoalTemplateListContainer />
					</Route>

					<Route path="/settings/goals/labels/new">
						<GoalLabelCreator />
					</Route>
					<Route path="/settings/goals/labels/:id">
						{({ match }) => <GoalLabelEditor id={match!.params.id!} />}
					</Route>
					<Route path="/settings/goals/labels">
						<GoalLabelsListContainer />
					</Route>

					<Route>
						<Redirect to="/settings/goals/templates" />
					</Route>
				</Switch>
			</Container>
		</>
	);
}
